export function getOrderArchiveNoticeDate (notice, user) {
  if (!notice || String(notice.by_admin_id) !== '0') return null
  if (!user || (!user.is_god && !(user.permissions || []).includes('order.archive'))) return null
  const match = /^订单日终(?:复查|检查)异常 (\d{4}-\d{2}-\d{2})$/.exec(notice.tit || '')
  return match ? match[1] : null
}
